import React from "react";
import "./style.css";
import CardChip from "../CardChip";
import ViewAllButton from "../ViewAllButton";

const TeamCardBox = ({ item, getTeamEvents, navigateToEvents }) => {
  return (
    <div
      className={`cards_of_team_comp ${item.class}`}
      onClick={() => {
        getTeamEvents ? getTeamEvents(item.official_name, item.sport_type) : navigateToEvents && navigateToEvents(item?.sportUrl) 
      }}
    >
      <div className="content_teamComp">
        {item.content && <p>{item?.content}</p>}
        <div className="all_ticket_btn">
          <ViewAllButton />
        </div>
      </div>
      <div className="card_chip">
        <CardChip
          name={item.official_name}
          cardColorClass={"competition_and_teams"}
        />
      </div>
    </div>
  );
};

export default TeamCardBox;
